(function () {
  'use strict';

  /* @ngdoc object
   * @name usuaris
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris', [
      'ui.router',
      'itecAdministracio.usuaris.main'
    ]);
}());
